import React from 'react';
import './List.style.scss'

const ListItem = (props) => {
    return (
        <div class="container paddingTop">
            <div class="row justify-content-center">
                <img style={{ width: "80px" }} src={props.image} alt="Logo" />
            </div>
            <div class="row justify-content-center text-center">
                <p class="h6" style={{ fontSize: "12px" }}>{props.name}</p>
                <p class="h6" style={{ fontSize: "10px" }}>{props.value} g</p>


            </div>
        </div>
    )
}
export default ListItem;